import { io } from "socket.io-client";
const SOCKET_SERVER_URL = "https://api-staging.areakart.in"; // Replace with your server URL

const socket = io(SOCKET_SERVER_URL, {
  path: "/ws/notifications",
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  autoConnect: false,
});

export default socket;
